module.exports = __webpack_public_path__ + "static/discord_company-51081bfbb8cfa387114e337c7391ec10.png";